module.exports = __webpack_public_path__ + "img/gmdl_icon1.e7acc14c.png";